import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";


class Dependencies{
    
    decodePaymentToken (payment_token){
        const base64 = base64_decode(payment_token);
        const jwt = jwt_decode(base64);
        return jwt
    }

    getCountryFromDomain = ()=>{
        let domain = window.location.hostname;
        if(domain === "ksa.paymob.com"){
            // Saudi Arabia
            return "SA"
        }else if(domain === "uae.paymob.com"){
            // United Emirates
            return "AE"
        }else if(domain === "pakistan.paymob.com"  || domain === "international-dev.paymob.com" || domain === "international-staging.paymob.com"){
            // Pakistan
            return "PK"
        }else if(domain === "oman.paymob.com"){
            // Oman
            return "OM"
        }else{
            // Egypt
            return "EG"
        }
    }
}

export let dependencies = new Dependencies();